import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface Locale {
  lang: string;
  data: Object;
}

@Injectable({
  providedIn: 'root'
})
export class CoreTranslationService {
  /**
   * Constructor
   *
   * @param {TranslateService} _translateService
   */

  constructor(private _translateService: TranslateService,
    @Inject(DOCUMENT) private document: Document  ) { }

  // Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Translate
   *
   * @param {Locale} args
   */
  translate(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach(locale => {
      // use setTranslation() with the third argument value as true to append translations instead of replacing them
      this._translateService.setTranslation(locale.lang, locale.data, true);
    });
  }

  get _translate(){
    return this._translateService;
  }
  getCurrentLang() {
    let currentLang = localStorage.getItem('lang');
    this._translateService.use(currentLang);
    if (currentLang == undefined) {
      currentLang = this._translateService.defaultLang;
    }
    if (currentLang == 'ar') {
      document.body.classList.add('rtl');
      this.document.documentElement.lang = 'ar';
      this.document.documentElement.dir = 'rtl';
    }
    else {
      this.document.documentElement.lang = 'en';
      this.document.documentElement.dir = 'ltr';
      document.body.classList.remove('rtl');
    }
    return currentLang;
  }
}
